<template>
    <div>
        <label class="lc_switch" :style="{'width' : width, 'height' : height}">
            <input type="checkbox" v-model="value_l" @change="$emit('input', value_l)" >
            <span class="lc_slider" :class="{'lc_checked' : value_l}">
                <span class="lc_slider_circle" :style="{'width' : p_circleSize_s, 'height' : p_circleSize_s}" :class="{'lc_checked' : value_l}">

                </span>
            </span>

        </label>
    </div>

</template>

<script>
    export default {
        name: "TqToggleSwitch",
        props:{
            value:{
                type: Boolean,
                require:true
            },
            width:{
                type: String,
                default : "57px"
            },
            height:{
                type: String,
                default : "30px"
            },
            sliderWidth:{
                type: String,
                default : "26px"
            },
            p_circleSize_s :{
                type: String,
                default : "23px"
            }
        },

        data(){
            return {
                value_l: false
            }

        },
        watch:{
            value:{
                handler(){
                    this.value_l = this.value
                },
                immediate:true
            }
        }
    }
</script>

<style scoped lang="scss">

    .lc_switch {
        position: relative;
        display: inline-block;

        input {
            display:none;
        }

        .lc_slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #ccc;
            -webkit-transition: .4s;
            transition: .4s;
            border-radius: 34px;

            &.lc_checked{
                background-color: #006400;
            }

            .lc_slider_circle {
                position: absolute;
                content: "";
                height: 23px;
                width: 23px;
                left: 4px;
                bottom: 4px;
                background-color: white;
                -webkit-transition: .4s;
                transition: .4s;
                border-radius: 50%;

                &.lc_checked{
                    -webkit-transform: translateX(100%);
                    -ms-transform: translateX(100%);
                    transform: translateX(100%);
                }
            }
        }




    }






</style>